import {MenuSection, PlayerStats} from "modules/enums";

function envOrEmpty(key: string) {
	return process.env[key] || "";
}

/**
 * Environment variables
 */
export const API_URL = envOrEmpty("REACT_APP_API_URL");
export const GLOBAL_API = envOrEmpty("REACT_APP_GLOBAL_API");
export const BASE_DOMAIN = envOrEmpty("REACT_APP_BASE_DOMAIN");
export const JSON_URL = envOrEmpty("REACT_APP_JSON_URL");
export const BASE_URL = envOrEmpty("REACT_APP_BASE_URL");
export const ENVIRONMENT = envOrEmpty("REACT_APP_ENVIRONMENT");
export const IMAGES_URL = envOrEmpty("REACT_APP_IMAGES_URL");
export const FB_SHARE_URL = envOrEmpty("REACT_APP_FB_SHARE_URL");
export const IS_LOC = window.location.href.includes(".loc");
export const IS_UAT = ENVIRONMENT === "uat";

export const UAT_URL =
	"https://mlb-by-the-numbers.uat.f2p.media.geniussports.com/apps/by-the-numbers/game";
export const UAT_URL_PUBLIC = "https://beta-gcp.mlb.com/apps/by-the-numbers/game";
export const PREPROD_URL =
	"https://mlb-by-the-numbers.preprod.f2p.media.geniussports.com/apps/by-the-numbers/game";
export const PROD_URL =
	"https://mlb-by-the-numbers.us.f2p.media.geniussports.com/apps/by-the-numbers/game";
export const PROD_URL_PUBLIC = "https://www.mlb.com/apps/by-the-numbers/game";
export const SENTRY_DOMAIN_ALLOWED = ".f2p.media.geniussports.com";

export const ANIMATION_DELAYS = {
	cardAnimationDelay: 1000,
	cardToggleDelay: 2500,
};
export const DEFAULT_TIMER_TIME = 10;
export const IMAGE_CACHE = Math.floor(Date.now() / 60000);

export const IS_SSO_BACKDOOR = JSON.parse(process.env.REACT_APP_IS_BACKDOOR || "false") as boolean;
export const GAME_ID = envOrEmpty("REACT_APP_GAME_ID");
export const MLB_PLAYER_AVATAR_IMAGES = envOrEmpty("REACT_APP_MLB_PLAYER_AVATAR_IMAGES");
export const MLB_PLAYER_SHOT_IMAGES = envOrEmpty("REACT_APP_MLB_PLAYER_SHOT_IMAGES");
export const MLB_PLAYER_FULL_IMAGES = envOrEmpty("REACT_APP_MLB_PLAYER_FULL_IMAGES");
export const REACT_APP_SKIP_BACKEND_IMAGES = JSON.parse(
	process.env.REACT_APP_SKIP_BACKEND_IMAGES || "false"
) as boolean;
export const IS_PROD = process.env.REACT_APP_ENVIRONMENT === "production";

export const CATEGORY_MAPPER = {
	[PlayerStats.JERSEY_NUMBER]: "Jersey number",
	[PlayerStats.AGE]: "Age",
	[PlayerStats.GAMES_PLAYED]: "Games Played",
	[PlayerStats.WINS]: "Wins",
	[PlayerStats.ERA]: "Era",
	[PlayerStats.STRIKEOUTS]: "Strike outs",
	[PlayerStats.HITS]: "Hits",
	[PlayerStats.BATTING_AVG]: "Batting avg",
	[PlayerStats.RBIS]: "Rbis",
	[PlayerStats.HOME_RUNS]: "Home runs",
	[PlayerStats.STOLEN_BASES]: "Stolen bases",
	[PlayerStats.FASTEST_PITCH]: "Fastest pitch",
	[PlayerStats.HIGHEST_EXIT_VELOCITY]: "Velocity",
};

export const EXIT_URL = envOrEmpty("REACT_APP_EXIT_URL");
export const FEEDBACK_URL = "https://mlb.az1.qualtrics.com/jfe/form/SV_cvkiZlw29pyF44S";
export const SHARE_LINK = envOrEmpty("REACT_APP_SHARE_URL");
export const LEADERBOARD_URL = envOrEmpty("REACT_APP_LEADERBOARD_URL");
export const IS_APP_DISABLED = JSON.parse(process.env.REACT_APP_DISABLED || "false") as boolean;

export const MENU_SECTIONS_MAPPER = {
	[MenuSection.HowToPlay]: 0,
	[MenuSection.Leaderboards]: 1,
	[MenuSection.Feedback]: 2,
};

export const NUM_CHANCES = 3;
